import axios from "axios"
let server = 'http://165.227.199.69:8092/api/'

/**Methods**/
export const POST = 'post'
const ROUTE = 'contactMail'

const RECEIVER = 'lopez.serrano.julio.c@gmail.com'
const APIKEY = 'FcH<4d}ce3T,);EY'
const SENDER = 'contacto@fyf.mx'
const SUBJECT = 'Petición de información'
/**Routes**/

/**Config Builder
 * @constructor
 * @param requestMethod{string}is the request method to be used when making the request -  Ej 'post'
 * @param route{string}  is the server URL that will be used for the request - Ej '/quienSoy'
 * @param params{string} are the URL parameters to be sent with the request -  Ej ['id','day']
 * @param data{Object} is the data to be sent as the request body -Only applicable for request methods 'PUT', 'POST', and 'PATCH'
 * @param headers
 * @param isFormData
 * **/

function config(requestMethod, route, data, params, headers, isFormData) {
  let auxHeaders = {authorization: `Bearer ${window.localStorage.token}`}
  if (isFormData) auxHeaders = {
    authorization: `Bearer ${window.localStorage.token}`,
    'content-type': 'multipart/form-data'
  }
  return {
    url: route,
    method: requestMethod,
    baseURL: server,
    headers: auxHeaders,
    params: params,
    data: data,
  }
}

export function execute(method, route, data, params, headers, responseType, server, isFormData) {
  return new Promise((resolve, reject) => {
    let conf = new config(method, route, data, params, headers, isFormData)
    if (server) conf.baseURL = server
    if (responseType) conf.responseType = responseType
    if (headers) Object.keysProp(headers).forEach(k => conf.headers[k] = headers[k])
    const aux = axios.request(conf)
      .then(r => {
        resolve(r.data)
      })
      .catch(e => {
        reject({message: e.response.data.message, status: e.response.status})
      })
  })
}

export function sendEmail({data,email}) {
  data.apiKey = APIKEY
  data.receiver = RECEIVER
  data.subject = SUBJECT
  data.sender = SENDER
  data.message += `\n${email}`
  console.log(data)
  return execute(POST, ROUTE, data)
}



